import './DisableDataSecurityButton.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { FullUserBoundary } from '@ui/general';
import { SonarText } from '@ui/text';
import { useAction } from '@hooks';
import { Button, Popconfirm } from 'antd';
import { CHANGE_EVENT_PREFERENCES, COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
export const DisableDataSecurityButton = ({ isEnabled }) => {
    const postDataSecurityStatus = useAction(coreActions.requestPostCoreDataSecurityStatus);
    const handleClick = useCallback(() => {
        postDataSecurityStatus({
            enable: false
        });
    }, [postDataSecurityStatus]);
    if (!isEnabled) {
        return null;
    }
    return (React.createElement(FullUserBoundary, null,
        React.createElement(Popconfirm, { cancelText: COPY_SPECIFIC.NO, okText: COPY_SPECIFIC.YES, onConfirm: handleClick, overlayClassName: 'disable-data-security-popover', placement: 'bottom', title: React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    React.createElement(SonarText, { className: 'disable-data-security-confirm-message' }, CHANGE_EVENT_PREFERENCES.DISABLE_CONFIRM_LINE1)),
                React.createElement("p", null,
                    React.createElement(SonarText, { className: 'disable-data-security-confirm-message' }, CHANGE_EVENT_PREFERENCES.DISABLE_CONFIRM_LINE2)),
                React.createElement("p", null,
                    React.createElement(SonarText, { className: 'disable-data-security-confirm-message' }, CHANGE_EVENT_PREFERENCES.DISABLE_CONFIRM_LINE3))) },
            React.createElement(Button, { className: 'disable-data-security-button', type: 'link' }, COPY_GENERIC.DISABLE))));
};
